import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-modal-cart-shiping-shedule',
    templateUrl: './modal-cart-shiping-shedule.component.html',
    styleUrls: ['./modal-cart-shiping-shedule.component.scss'],
    standalone: false
})
export class ModalCartShipingSheduleComponent implements OnInit, OnDestroy {

  constructor() { }

  ngOnInit(): void {
  }
ngOnDestroy(): void {
  }
}
